import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonIconComponent } from './button-icon.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    ButtonIconComponent
  ],
  exports: [
    ButtonIconComponent
  ]
})

export class ButtonIconModule {}
